import { FC, useEffect, useRef } from 'react';
import { Flex, ThemeUIStyleObject } from 'theme-ui';
import useSiteWideBanner from '~/hooks/components/use-site-wide-banner';

type Props = {
  setInnerRef: (ref: React.RefObject<HTMLElement>) => void;
};

const SiteWideBanner: FC<Props> = ({ setInnerRef }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Trigger recalculation
    setInnerRef(ref);
  }, [setInnerRef]);
  const { siteWideBanner, mobileSiteWideBanner } = useSiteWideBanner();

  if (!siteWideBanner?.description?.childMarkdownRemark?.html) return null;

  const sharedStyles: ThemeUIStyleObject = {
    minHeight: '44px',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: '12px',
  };

  return (
    <>
      <Flex
        ref={ref}
        sx={{
          display: mobileSiteWideBanner ? ['none', 'flex'] : 'flex',
          background: siteWideBanner.backgroundColor ?? '#E1E1E1',
          color: siteWideBanner.textColor ?? 'black',
          ...sharedStyles,
        }}
        dangerouslySetInnerHTML={{
          __html: siteWideBanner.description.childMarkdownRemark.html,
        }}
      />
      {mobileSiteWideBanner?.description?.childMarkdownRemark?.html && (
        <Flex
          ref={ref}
          sx={{
            display: mobileSiteWideBanner ? ['flex', 'none'] : 'none',
            background: mobileSiteWideBanner?.backgroundColor ?? '#E1E1E1',
            color: mobileSiteWideBanner?.textColor ?? 'black',
            ...sharedStyles,
          }}
          dangerouslySetInnerHTML={{
            __html: mobileSiteWideBanner.description.childMarkdownRemark.html,
          }}
        />
      )}
    </>
  );
};

export default SiteWideBanner;
